'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Slide = require('./Slide');

Object.defineProperty(exports, 'Slide', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Slide).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./src/containers/Slide/index.js
// module id = 1850
// module chunks = 0